module.exports = __webpack_public_path__ + "img/20221110_FTX_incident.e61d3430.png";